import React from 'react';
import { ScoringRules, TopScorer, UserTeams } from '../../types';
import NameLink from '../NameLink/NameLink';

interface TopScorerCardWC26Props {
  topScorer: TopScorer;
  teamAllocs: UserTeams[];
  scoringRules: ScoringRules;
  index: number;
}

const RANK_CLASSES = ['gold', 'silver', 'bronze'];
const RANK_LABELS = ['🥇', '🥈', '🥉'];

function TopScorerCardWC26({
  topScorer, teamAllocs, scoringRules, index,
}: TopScorerCardWC26Props) {
  const userNames = teamAllocs
    .filter(
      (a) => a.team1Id === topScorer.teamId.toString() || a.team2Id === topScorer.teamId.toString()
    )
    .map((a) => a.name);

  const points = index === 0 ? scoringRules.goldenBoot : 0;

  return (
    <div className="top-scorers-wc26-card">
      <div className={`top-scorers-wc26-rank ${RANK_CLASSES[index] ?? ''}`}>
        {RANK_LABELS[index] ?? index + 1}
      </div>
      <div className="top-scorers-wc26-player">
        <img src={topScorer.photo} alt={topScorer.name} />
        <p>{topScorer.name}</p>
      </div>
      <div className="top-scorers-wc26-team">
        <img src={topScorer.teamLogo} alt={topScorer.teamName} />
        <p>{topScorer.teamName}</p>
        {userNames.length > 0 && (
          <div className="top-scorers-wc26-team-names">
            {userNames.map((userName, i) => (
              <React.Fragment key={userName}>
                {i > 0 && ', '}
                <NameLink name={userName} />
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
      <div className="top-scorers-wc26-goals">{`${topScorer.goals}g`}</div>
      <div className={`top-scorers-wc26-points ${points > 0 ? 'positive' : 'neutral'}`}>
        {points > 0 ? `+${points}` : '-'}
      </div>
    </div>
  );
}

export default TopScorerCardWC26;
